var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column muted-wrapper",attrs:{"id":"app"}},[_c('main',{staticClass:"container my-5 flex-grow-1 d-flex align-items-center",attrs:{"role":"main"}},[_c('router-view')],1),_c('PageFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }